import { Component, OnInit, Input } from '@angular/core';

import { 
    IonAvatar
} from '@ionic/angular/standalone';

import { environment } from '@app/environment';

export class RetailerLogo{
    retailer: string;
    logo: string;
    constructor(retailer: string){
        this.retailer = retailer;
        this.logo = environment.URL_LOGO_RETAILER.replace('#retailer_name#', retailer) || '';
    }
}

@Component({
    selector: 'app-retailer-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    imports: [IonAvatar]
})
export class RetailerLogoComponent  implements OnInit {

    @Input({alias : 'retailer', required : true}) retailerLogo: RetailerLogo;
    @Input({alias : 'size', required : false}) sizeLogo: 'big'|'medium'|'small' = 'medium';
    @Input({alias : 'withMarginRight', required : false}) withMarginRight: boolean = true;

    displayLogo: boolean = true;

    constructor() { }

    ngOnInit() {}
        
    onImgError(event: any){
        this.displayLogo = false;
    }
}
